import { useState } from "react"
import classnames from "classnames"
import parse from "html-react-parser"

import ServiceList from "./service_list"

import styles from "./ingredient_listbox.module.scss"

interface Props {
  apiList: ApiList
  name: string
  serviceList: Service[]
}

interface ApiList {
  options: Array<string> | Record<string, Array<string>>
  placeholder: string
  helpText?: {
    [key: string]: string
  }
}

interface Service {
  image: string
  module_name: string
  name: string
  normalized_module_name: string
}

import closedChevron from "images/layout/chevron-right-black.svg?raw"
import openedChevron from "images/layout/chevron-down.svg?raw"

const IngredientListbox = (props: Props) => {
  const [listOpened, updateListVisibility] = useState(false)

  if (!props.apiList?.options) return null

  const copyContent = e => {
    const target = e.target.classList.contains("copy-content") ? e.target : e.target.parentNode

    navigator.clipboard.writeText(target.title)
    target.classList.add("copied")
    const input = target.querySelector("input") as HTMLInputElement | null
    if (input) input.select()
    setTimeout(() => {
      target.classList.remove("copied")
    }, 1500)
  }

  const renderList = (serviceName: string, options: Array<string>) => (
    <>
      <li className={styles.service}>{serviceName}</li>
      <li className={styles["service-options"]}>
        <ul>
          {options.map(option => (
            <li
              key={`${serviceName}.${option}`}
              title={`${serviceName}.${option}`}
              onClick={copyContent}
              className="copy-content"
            >
              <input type="text" readOnly value={`.${option}`} />
            </li>
          ))}
        </ul>
      </li>
    </>
  )

  const renderFlatList = (options: Array<string>) => (
    <li className={styles["service-options"]}>
      <ul>
        {options.map(option => (
          <li key={option} title={option} onClick={copyContent} className="copy-content">
            <input type="text" readOnly value={option} />
          </li>
        ))}
      </ul>
    </li>
  )

  const renderLimits = () => {
    if (!props.apiList.helpText) return null

    return (
      <li className={styles["help-text"]}>
        <ul>
          {Object.values(props.apiList.helpText).map(value => (
            <li key={value}>{value}</li>
          ))}
        </ul>
      </li>
    )
  }

  const isArrayOptions = Array.isArray(props.apiList.options)

  return (
    <section className={classnames(styles["ingredient-combo-container"], "mb4")}>
      <header>
        <span className={styles["header-name"]}>{props.name}</span>
        {props.serviceList?.length && (
          <span className={styles["service-list"]}>
            <ServiceList context={props.name} services={props.serviceList} />
          </span>
        )}
      </header>

      <ul role="listbox" className={classnames(styles["ingredient-combobox"], "mt1", { [styles.opened]: listOpened })}>
        <li
          className={styles.placeholder}
          onClick={() => updateListVisibility(!listOpened)}
          title={listOpened ? "Click to close" : "Click to open"}
        >
          <span>{props.apiList.placeholder}</span>
          <span>{parse(listOpened ? openedChevron : closedChevron)}</span>
        </li>
        {listOpened && (
          <>
            {isArrayOptions
              ? renderFlatList(props.apiList.options as Array<string>)
              : Object.entries(props.apiList.options as Record<string, Array<string>>).map(([serviceName, options]) =>
                  renderList(serviceName, options)
                )}
            {renderLimits()}
          </>
        )}
      </ul>
    </section>
  )
}

export default IngredientListbox
